module.exports = __webpack_public_path__ + "img/transform_pdf.989cdcd5.svg";